var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forward-action-view"},[_c('validation',{attrs:{"setup":{
      'func': function (args) { return args; },
      'args': {
        'key': 'targets',
        'validation': 'required'
      }
    }}},[_c('check-channels-list',{model:{value:(_vm.model.targets),callback:function ($$v) {_vm.$set(_vm.model, "targets", $$v)},expression:"model.targets"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }